/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'window',
    'pip-model',
    'javascript-debounce'
  ],
  function (
    $,
    window,
    pip,
    debounce
  ) {

    var goToTopTemplate = '<button id="goToTop">' +
                            '<div class="go-to-top go-to-top--hide" />' +
                          '</button>';
    var view = {
      selectors: {
        goToTopContainer: '#goToTop',
        goToTopButton: '.go-to-top',
        goToTopButtonHide: '.go-to-top--hide',
        goToTopButtonVisible: '.go-to-top--visible',
        buyArea: '#pipContainer .pip-row'
      },
      classes: {
        goToTopButtonHide: 'go-to-top--hide',
        goToTopButtonVisible: 'go-to-top--visible'
      },
      initDOM: function init() {
        $('body').append(goToTopTemplate);
      },
      initEventListeners: function initEventListeners() {
        $(view.selectors.goToTopContainer).on('click', function(e) {
          scrollToTop();
        });

        $(window.document).scroll(function() {
          debounce(handleTopButton(), 100);
        })
      }
    };

    function handleTopButton() {
      var offset = 70;
      var buyAreaHeight = $(view.selectors.buyArea).first().height() + offset;
      var scrollBreakpoint = buyAreaHeight > 700 && buyAreaHeight < 1700
        ? buyAreaHeight
        : 1000;

      var scroll = window.pageYOffset || document.documentElement.scrollTop;

      var backToTop = scroll > scrollBreakpoint;
      if (backToTop) {
        $(view.selectors.goToTopButton)
          .removeClass(view.classes.goToTopButtonHide)
          .addClass(view.classes.goToTopButtonVisible);
      } else {
        $(view.selectors.goToTopButton)
          .removeClass(view.classes.goToTopButtonVisible)
          .addClass(view.classes.goToTopButtonHide);
      }
    }

    function scrollToTop() {
      var smoothnessValue = 5;
      if (typeof window !== 'undefined') {
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollPosition > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, scrollPosition - (Math.ceil(scrollPosition / smoothnessValue)));
        }
      }
    }

    return {
      init: function () {
        if (pip.features.goToTopButtonEnabled) {
          view.initDOM();
          view.initEventListeners();
        }
      },
      view: view
    }
  });

}.call(window));